import { CameraDetail } from '@hakimo-ui/hakimo/types';
import { useCanUpdateCamera } from '@hakimo-ui/hakimo/util';
import { SettingSectionActions } from './SettingSectionActions';
import SettingSectionAudioDevices from './SettingSectionAudioDevices';
import { SettingSectionCreds } from './SettingSectionCreds';
import { SettingSectionDelete } from './SettingSectionDelete';

interface Props {
  camera: CameraDetail;
  onDeletedCamera: () => void;
}

export function CameraSettings(props: Props) {
  const { camera, onDeletedCamera } = props;
  const canUpdateCamera = useCanUpdateCamera();

  return (
    <div className="flex flex-col gap-6">
      <SettingSectionActions camera={camera} />
      <SettingSectionAudioDevices camera={camera} />
      {canUpdateCamera && <SettingSectionCreds camera={camera} />}
      {canUpdateCamera && (
        <SettingSectionDelete camera={camera} onDeleted={onDeletedCamera} />
      )}
    </div>
  );
}
